<template>
  <template v-if="secondary">
    <LogoSVGCH2 v-bind="$attrs" v-if="sport === SPORTS.HOCKEY" />
    <LogoSVGCHand2 v-bind="$attrs" v-else-if="sport === SPORTS.HANDBALL" />
    <LogoSVGCT2 v-bind="$attrs" v-else />
  </template>
  <template v-else>
    <LogoSvgCH v-bind="$attrs" v-if="sport === SPORTS.HOCKEY" />
    <LogoSvgCHand v-bind="$attrs" v-else-if="sport === SPORTS.HANDBALL" />
    <LogoSvgCT v-bind="$attrs" v-else />
  </template>
</template>
<script setup lang="ts">
import LogoSvgCH from '@/assets/images/logos/logo-ch.svg?component'
import LogoSVGCH2 from '@/assets/images/logos/logo-ch-2.svg?component'
import LogoSvgCHand from '@/assets/images/logos/logo-chand.svg?component'
import LogoSVGCHand2 from '@/assets/images/logos/logo-chand-2.svg?component'
import LogoSvgCT from '@/assets/images/logos/logo-ct.svg?component'
import LogoSVGCT2 from '@/assets/images/logos/logo-ct-2.svg?component'
import { SPORTS } from '@/utils/variables'

defineProps<{
  sport?: string
  secondary?: boolean
}>()
</script>
